var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.fieldEdited
    ? _c(
        "div",
        [
          _c("div", {
            staticClass: "content-input",
            style: {
              borderColor: _vm.borderColor,
              backgroundColor: _vm.backgroundColor
            },
            attrs: {
              id: this.content.path,
              contenteditable: "true",
              spellcheck: "true"
            },
            domProps: { innerHTML: _vm._s(_vm.editedContent()) },
            on: { blur: _vm.contentBlurred, focus: _vm.contentFocused }
          }),
          _vm._v(" "),
          _c(
            "b-tooltip",
            {
              attrs: {
                disabled: _vm.showOriginalText,
                target: this.content.path,
                placement: "topright",
                triggers: "focus"
              },
              on: {
                "update:disabled": function($event) {
                  _vm.showOriginalText = $event
                }
              }
            },
            [
              _c("strong", [_vm._v("Original Text")]),
              _vm._v(" "),
              this.content.original_value &&
              this.content.original_value.trim() === ""
                ? _c("div", [_vm._v("\n      N/A\n    ")])
                : _c("div", [
                    _vm._v(
                      "\n      " +
                        _vm._s(this.content.original_value) +
                        "\n      "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Modified By")]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n      " + _vm._s(this.content.edited_by) + "\n    "
                    )
                  ])
            ]
          ),
          _vm._v(" "),
          _vm.hidePopOver
            ? _c(
                "b-popover",
                {
                  attrs: {
                    target: this.content.path,
                    placement: "top",
                    triggers: "focus",
                    boundary: "window"
                  }
                },
                [
                  _c("div", { staticClass: "canvas-wrapper" }, [
                    _c("canvas", {
                      attrs: { id: "canvas_" + this.content.path }
                    })
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "content-input",
              style: {
                borderColor: _vm.borderColor,
                backgroundColor: _vm.backgroundColor
              },
              attrs: {
                id: this.content.path,
                contenteditable: "true",
                spellcheck: "true"
              },
              on: { focus: _vm.contentFocused, blur: _vm.contentBlurred }
            },
            _vm._l(
              this.content.ocr_text && this.content.ocr_text.words,
              function(word) {
                return _c("span", [
                  word["characters"]
                    ? _c(
                        "span",
                        _vm._l(word["characters"], function(character) {
                          return _c("span", [
                            _vm.isNewLine(character["letter"])
                              ? _c("span", [_c("br")])
                              : _c(
                                  "span",
                                  { style: { color: _vm.setColor(character) } },
                                  [_vm._v(_vm._s(character["letter"]))]
                                )
                          ])
                        })
                      )
                    : _c("span", [
                        _c("span", [_vm._v(_vm._s(word["text"] + " "))])
                      ])
                ])
              }
            )
          ),
          _vm._v(" "),
          _vm.hidePopOver
            ? _c(
                "b-popover",
                {
                  attrs: {
                    target: this.content.path,
                    placement: "top",
                    triggers: "focus",
                    boundary: "window"
                  }
                },
                [
                  _c("div", { staticClass: "canvas-wrapper" }, [
                    _c("canvas", {
                      attrs: { id: "canvas_" + this.content.path }
                    })
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b302c582", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b302c582","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/contentEditable.vue
// module id = 1166
// module chunks = 2